import { Toast } from "@newsela/angelou";
import { capitalize } from "@s-libs/micro-dash";

import AUTH_PROVIDER_NAME_TRANSFORMATIONS from "@/constants/AUTH_PROVIDER_NAME_TRANSFORMATIONS";

export const getProviderName = (provider) =>
  AUTH_PROVIDER_NAME_TRANSFORMATIONS[provider] || capitalize(provider);

export const EVENT_TOAST_FAIL = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Request failed",
};
